import {
  getAdminV1StoresStoreIdFeeds,
  postAdminV1StoresStoreIdFeedsChannelRotateToken,
  type FeedChannel,
  type FeedStatus,
  type FeedToken,
} from '@nucleus-commerce/api-client/admin';

/** Product feed status per channel and the per-channel URL token. */
export const feedsApi = {
  status: (storeId: string): Promise<FeedStatus> => getAdminV1StoresStoreIdFeeds({ storeId }),
  /** Creates or rotates the channel's token; the previous URL stops working at once. */
  rotate: (storeId: string, channel: FeedChannel): Promise<FeedToken> =>
    postAdminV1StoresStoreIdFeedsChannelRotateToken({ storeId, channel }),
};
